import {Component, OnInit} from '@angular/core';
import {BasePageComponent} from "../../base-page.component";
import {WorkService} from "../../services/domain/work.service";
import {AplDto, EsperienzaLavoroDto, MansioniDto} from "../../models/lavoro.models";
import {SharedEnumModelKeyValue} from "../../models/shared.models";
import {UtilsService} from "../../services/utils.service";
import {AuthService} from "../../services/auth.service";
import {ConfirmationService, ConfirmEventType} from "primeng/api";
import {LocaleSettings} from "primeng/calendar";

@Component({
  selector: 'app-work',
  templateUrl: './work.component.html',
  styleUrls: ['./work.component.css'],
  providers : [WorkService,ConfirmationService]
})
export class WorkComponent extends BasePageComponent  implements OnInit{

  constructor(private workService : WorkService,
              private confirmationService: ConfirmationService) {
    super();

  }

  public currentWorkExperience : EsperienzaLavoroDto = new EsperienzaLavoroDto();
  public workExperiences : EsperienzaLavoroDto[] = [];
  public workExperienceSelected : EsperienzaLavoroDto = new EsperienzaLavoroDto();
  public occupationTypesList : SharedEnumModelKeyValue[] = [];
  public taskList : MansioniDto[] = [];
  public taskSelected : MansioniDto[] = [];
  public aplList : AplDto[] = [];
  public aplSelected : AplDto = new AplDto();
  public showDialog : boolean = false;
  public headerDialog : string = "";

  ngOnInit(): void {
    this.getWorkExperience();
  }

  public getWorkExperience(){
    this.asyncCall(() => this.workService.getWorkExperience(AuthService.LoggedUser?.profileId ?? 0), response => {
      this.workExperiences = response.Items || [];
      this.setCurrentWorkExperience();
    });
  }

  public editWorkExperience(workEsperience : EsperienzaLavoroDto){
    this.headerDialog = "Modifica esperienza di lavoro";
    this.workExperienceSelected = workEsperience;
    this.getTaskByWorkExperienceId();
    this.setDatesObjects();
    this.getOccupationStateList();
    this.getAplList(null);
    if(this.workExperienceSelected.IdAPL){
      this.aplSelected = new AplDto();
      this.aplSelected.IdApl = this.workExperienceSelected.IdAPL;
      this.aplSelected.AplDesc = this.workExperienceSelected.APL;
    }
    this.showDialog = true;
  }

  public deleteWorkExperience(idWork : number){
    this.confirmationService.confirm({
      message: 'Sicuro di voler eliminare questa esperienza lavorativa?',
      header: 'Richiesta conferma',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.asyncCall(() => this.workService.workExperienceDelete(idWork), response =>{
          this.showSuccess("Dati eliminati correttamente");
          this.getWorkExperience();
        })
      }
    });
  }

  public insertNewWorkExperience(){
    this.workExperienceSelected = new EsperienzaLavoroDto();
    this.workExperienceSelected.TipoContratto = 0;
    this.taskSelected = [];
    this.headerDialog = "Aggiungi esperienza di lavoro";
    this.getOccupationStateList();
    this.getAplList(null);
    this.showDialog = true;
  }

  public getOccupationStateList(){
    this.asyncCall(() => this.workService.getOccupationStateList(), response => {
      this.occupationTypesList = response.Items || [];
      this.occupationTypesList = this.occupationTypesList.filter(x => x.Key != 5 && x.Key != 4);
    });
  }

  public getTaskByWorkExperienceId(){
    this.asyncCall(() => this.workService.getTaskByWorkExperienceId(this.workExperienceSelected.IdAnagraficaUtenteEspProf), response => {
      this.taskSelected = response.Items || [];
    });
  }

  public getTaskList(event : any){
    if(event == null)
      return;

    if(event.query.length < 3)
      return;

    this.asyncCall(() => this.workService.getTaskAutocomplete(event.query), response => {
      this.taskList = response.Items || [];
    });
  }

  public getAplList(event : any){
    this.asyncCall(() => this.workService.getAplList(), response => {
      this.aplList = response.Items || [];
      if(event == null)
        return;

      this.aplList = this.aplList.filter(
        apl => apl.AplDesc != null && apl.AplDesc.toUpperCase().search(event.query.toUpperCase()) >= 0);
    });
  }

  public changeInCorso(){
    if(this.workExperienceSelected.InCorso)
      this.workExperienceSelected.DataFine = null;
  }

  public closeModal(){
    this.showDialog = false;
    this.headerDialog = "";
    this.workExperienceSelected = new EsperienzaLavoroDto();
  }

  public workExperienceUpsert(){
    if(this.taskSelected.length > 0){
      this.workExperienceSelected.IdMansioneList = '';
      for(let i = 0; i < this.taskSelected.length; i++){
        if(i == this.taskSelected.length -1)
          this.workExperienceSelected.IdMansioneList += this.taskSelected[i].IdMansione;
        else
          this.workExperienceSelected.IdMansioneList += this.taskSelected[i].IdMansione + ",";
      }
      if(this.workExperienceSelected.Professione == "" || this.workExperienceSelected.Professione == null)
        this.workExperienceSelected.Professione = this.taskSelected[0].MansioneDesc;
    }
    else{
      this.workExperienceSelected.Professione = "";
      this.workExperienceSelected.IdMansioneList = "";
    }

    if(this.aplSelected.IdApl > 0)
      this.workExperienceSelected.IdAPL = this.aplSelected.IdApl;

    if(this.workExperienceSelected.IdAnagraficaUtente == null || this.workExperienceSelected.IdAnagraficaUtente == 0)
      this.workExperienceSelected.IdAnagraficaUtente = AuthService.LoggedUser?.profileId ?? 0;

    this.workExperienceSelected.DataInizio = UtilsService.SetHourTO_DATE(this.workExperienceSelected.DataInizio);
    if(this.workExperienceSelected.DataFine != null){
      this.workExperienceSelected.DataFine = UtilsService.SetHourTO_DATE(this.workExperienceSelected.DataFine);
    }
    if(this.workExperienceSelected.TipoContratto != 0 && this.workExperienceSelected.Azienda != ""){
      if(this.workExperienceSelected.DataFine!=null &&this.workExperienceSelected.DataFine < this.workExperienceSelected.DataInizio){
        this.showError("Attenzione: Data di fine lavoro non valida");
      }
      else{
        this.asyncCall(() => this.workService.workExperienceUpsert(this.workExperienceSelected), response => {
          this.showMessageSaveCompleted();
          this.getWorkExperience();
          this.closeModal();
        });
      }
    }
    else{
      this.showError("Attenzione: Popolare Anagrafica");

      if(this.workExperienceSelected.DataFine!= null && this.workExperienceSelected.DataFine < this.workExperienceSelected.DataInizio)
        this.showError("Attenzione: Data di fine lavoro non valida");
    }
  }

  private setCurrentWorkExperience(){
    this.currentWorkExperience = this.workExperiences[0];
  }

  private setDatesObjects(): void {
    if(this.workExperienceSelected.DataInizio != null)
      this.workExperienceSelected.DataInizio = UtilsService.ConvertTo_DATEMONTH_DATABASE_FORMAT(this.workExperienceSelected.DataInizioStr);

    if(this.workExperienceSelected.DataFineStr == "in corso"){
      this.workExperienceSelected.InCorso = true;
      this.workExperienceSelected.DataFine = null;
    }else if(this.workExperienceSelected.DataFine != null)
      this.workExperienceSelected.DataFine = UtilsService.ConvertTo_DATEMONTH_DATABASE_FORMAT(this.workExperienceSelected.DataFineStr);
  }

  private setDataBeforeSave(){
    if(this.workExperienceSelected.DataInizio != null)
      this.workExperienceSelected.DataInizio = UtilsService.ConvertDateToTimeZoneIta(this.workExperienceSelected.DataInizio);

    if(this.workExperienceSelected.DataFine != null)
      this.workExperienceSelected.DataFine = UtilsService.ConvertDateToTimeZoneIta(this.workExperienceSelected.DataFine);

  }


}
